module.exports = __webpack_public_path__ + "img/logo-dark.3da4018b.png";